import { Loader2 } from 'lucide-react';
import { useI18n } from '@/context/I18nContext';

interface Props {
  message?: string;
}

export function LoadingSpinner({ message }: Props) {
  const { t } = useI18n();
  return (
    <div className="flex items-center gap-2 py-8 px-5 text-text-muted text-sm">
      <Loader2 className="w-4 h-4 text-accent animate-spin flex-shrink-0" />
      {message ?? t('common.loading')}
    </div>
  );
}
